import { useState } from "react";
import {
  Typography,
  Button,
  AppBar,
  IconButton,
  Toolbar,
  DialogContent,
  Stack,
  Box,
} from "@mui/material";
import {
  Close as CloseIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import MaterialReactTable from "material-react-table";
import getColumns from "./ViewDoctorColumns";
import { RecapitiDoctor } from "../index";
import { LoadingError, LoadingPaper } from "../../LoadingComponents";
import { useEffect } from "react";

import { useGetDoctorById, usePutDoctorById } from "../useDoctorQueries";
import { useEditMode } from "../../EditableComponents";

function ViewDoctor({ doctor_id, closeModal, _editMode }) {
  // === web service queries/mutations  ===
  const doctorQuery = useGetDoctorById(doctor_id);
  const editMutation = usePutDoctorById(doctor_id, closeModal);

  // === EditMode handling ===
  const {
    editMode,
    enterEditMode,
    confirmEditMode,
    updateEditState,
  } = useEditMode({
    editModeEnabled: _editMode,
    updateMutation: editMutation,
    initialQueryKey: ["doctors", doctor_id],
  });

  useEffect(() => {
    if (_editMode) enterEditMode();
  }, []);

  const tableColumns = getColumns(editMode, updateEditState);

  return (
    <>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={closeModal}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      {doctorQuery.isLoading ? (
        <LoadingPaper />
      ) : doctorQuery.isError ? (
        <LoadingError error={doctorQuery.error} />
      ) : (
        <DialogContent>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h5" component="div">
            Visualizza professionista sanitario:{" "}
            {`${doctorQuery.data.first_name} ${doctorQuery.data.last_name}`}
          </Typography>

          <Stack spacing={2} direction={"column"}>
            <Box sx={{ width: "100%" }}>
              {/* Azioni */}
              <Box sx={{ float: "left" }}>
                <Button // MODIFICA
                  style={{ margin: "5px" }}
                  color={editMode ? "success" : "warning"}
                  variant="contained"
                  onClick={editMode ? confirmEditMode : enterEditMode}
                >
                  <EditIcon sx={{ marginRight: "5px" }} />
                  {editMode ? "Conferma" : "Modifica"}
                </Button>
              </Box>

              {/* <Box sx={{ float: "right" }}>
                <Button
                  style={{ margin: "5px" }}
                  color="primary"
                  variant="contained"
                >
                  <EmailIcon sx={{ marginRight: "5px" }} />
                  Invia Email
                </Button>

                <Button
                  style={{ margin: "5px" }}
                  color="primary"
                  variant="contained"
                >
                  <SmsIcon sx={{ marginRight: "5px" }} />
                  Invia Messaggio
                </Button>
              </Box> */}
            </Box>
            {/* Informazioni di base */}
            <MaterialReactTable
              columns={tableColumns}
              data={[doctorQuery.data]}
              enableColumnActions={false}
              enableColumnFilters={false}
              enablePagination={false}
              enableSorting={false}
              enableBottomToolbar={false}
              enableTopToolbar={false}
              muiTableBodyRowProps={{ hover: false }}
              renderDetailPanel={({ row }) => (
                <RecapitiDoctor
                  _doctor={row.original}
                  editMode={editMode}
                  setParentValue={updateEditState}
                />
              )}
            />
          </Stack>
        </DialogContent>
      )}
    </>
  );
}

export default ViewDoctor;
